import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconThumbsDownSvg } from './IconThumbsDownSvg';

export type IconThumbsDownProps = UseIconProps;

export function IconThumbsDown(props: IconThumbsDownProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconThumbsDownSvg} {...iconProps} />;
}
